export enum usersType {
    all = 'ALL',
    admin = 'ADMIN',
    office = 'OFFICE',
    normalUser = 'USER',
    superVisor = 'SUPERVISOR'
}